<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="manual-flood-irrigation-modal">
  <div style="background-color: #548235; height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 style="color: rgb(10, 10, 10); text-transform: none;">Manual Irrigation for '{{eventName}}'</h5>
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times" type="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
    </button>
  </div>

  <div class="modal-body">
    <div *ngFor="let action of actions; let i = index">
      <hr *ngIf="i > 0" style="margin: 20px 0;">

      <div class="action-title">Fill Zone: {{action.fillZone}} / Drain Zone: {{action.drainZone}}</div>

      <div class="irrigation-controls">
        <!-- Fill Time -->
        <div class="control-group">
          <label class="control-label">Fill Time</label>
          <div class="stepper">
            <button class="stepper-btn" (click)="decrementFillTime(i)" [disabled]="action.fillTimeSeconds <= 0">&#8722;</button>
            <span class="stepper-value">{{ action.fillTimeSeconds / 60 | number:'1.0-0' }}</span>
            <button class="stepper-btn" (click)="incrementFillTime(i)" [disabled]="action.fillTimeSeconds >= 10 * 60">+</button>
          </div>
          <label class="control-unit">Minutes</label>
        </div>

        <!-- Hold Time -->
        <div class="control-group">
          <label class="control-label">Hold Time</label>
          <div class="stepper">
            <button class="stepper-btn" (click)="decrementHoldTime(i)" [disabled]="action.holdTimeSeconds <= 0">&#8722;</button>
            <span class="stepper-value">{{ action.holdTimeSeconds / 60 | number:'1.0-0' }}</span>
            <button class="stepper-btn" (click)="incrementHoldTime(i)" [disabled]="action.holdTimeSeconds >= 60 * 60">+</button>
          </div>
          <label class="control-unit">Minutes</label>
        </div>

        <!-- Drain Time -->
        <div class="control-group">
          <label class="control-label">Drain Time</label>
          <div class="stepper">
            <button class="stepper-btn" (click)="decrementDrainTime(i)" [disabled]="action.drainTimeSeconds <= 0">&#8722;</button>
            <span class="stepper-value">{{ action.drainTimeSeconds / 60 | number:'1.0-0' }}</span>
            <button class="stepper-btn" (click)="incrementDrainTime(i)" [disabled]="action.drainTimeSeconds >= 60 * 60">+</button>
          </div>
          <label class="control-unit">Minutes</label>
        </div>
      </div>

      <div class="control-group" style="margin-top: 10px;">
        <label class="control-label">Total Cycle Time: &nbsp;&nbsp;{{ (action.fillTimeSeconds + action.holdTimeSeconds + action.drainTimeSeconds) / 60 | number:'1.0-0' }} Minutes </label>
        <label style="margin-top: -15px;">(values rounded to nearest minute)</label>
      </div>

      <!-- Scaled Flood Cycle Graphic -->
      <div class="flood-graphic">
        <div class="flood-graphic-bar">
          <div class="flood-segment fill-segment" [style.flex]="action.fillTimeSeconds" *ngIf="action.fillTimeSeconds > 0"></div>
          <div class="flood-segment hold-segment" [style.flex]="action.holdTimeSeconds" *ngIf="action.holdTimeSeconds > 0"></div>
          <div class="flood-segment drain-segment" [style.flex]="action.drainTimeSeconds" *ngIf="action.drainTimeSeconds > 0"></div>
        </div>
        <div class="flood-graphic-labels">
          <div class="segment-label" [style.flex]="action.fillTimeSeconds" *ngIf="action.fillTimeSeconds > 0">Fill</div>
          <div class="segment-label" [style.flex]="action.holdTimeSeconds" *ngIf="action.holdTimeSeconds > 0">Hold</div>
          <div class="segment-label" [style.flex]="action.drainTimeSeconds" *ngIf="action.drainTimeSeconds > 0">Drain</div>
        </div>
      </div>
    </div>

    <div class="modal-actions" style="margin-top: 20px;">
      <button class="btn btn-default" (click)="cancel()">Cancel</button>
      <button class="btn btn-success" (click)="execute()">Execute</button>
    </div>
  </div>
</div>
